import settingServiceActions from 'features/settingService/services/actions';
import settingApis from 'features/settingService/services/apis';
import { DISCOUNT_VALUE_TYPE } from 'features/settingService/services/constants';
import { ICategoryUpdateInfoServiceItem, IEditCateBodyType } from 'features/settingService/services/types/api';
import { useSetLoadingPage } from 'services/UI/LoadingPage';
import { IResponseDataBody } from 'services/response';
import shopActions from 'services/shop/actions';
import { ICategoryItemData } from 'services/shop/types/categories';
import { useAppDispatch } from 'store/hooks';

const useSettingService = () => {
  const dispatch = useAppDispatch();
  const setLoadingPage = useSetLoadingPage();

  const setActiveCate = (_activeCate: ICategoryItemData | null) => {
    dispatch(settingServiceActions.serviceActs.activeCate(_activeCate?.id || null));
  };

  const boundaryFuncWrapper = async (asyncFunc: () => Promise<any>) => {
    setLoadingPage(true);
    try {
      const res: IResponseDataBody<boolean> = await asyncFunc();
      if (res.data.data) {
        dispatch(shopActions.getNewCategories.fetch());
      }
    } catch (error) { }
    finally {
      setLoadingPage(false);
    }
  };

  const deleteServices = (ids: string[]) => boundaryFuncWrapper(
    () => settingApis.deleteMultiple(ids)
  );

  const applySupplyFee = (cateId: string, value: number) => boundaryFuncWrapper(
    () => settingApis.categoryApplySupplyFee(cateId, value)
  );

  const editNameCate = (cateId: string, value: string) => boundaryFuncWrapper(
    () => settingApis.categoryEditName(cateId, value),
  );

  const editNameService = async (id: string, value: string) => boundaryFuncWrapper(
    () => settingApis.serviceEditName(id, value),
  );

  const updateInfoServices = async (body: ICategoryUpdateInfoServiceItem[]) => boundaryFuncWrapper(
    () => settingApis.categoryUpdateInfoServices(body),
  );

  const deleteCategory = async (id: string) => boundaryFuncWrapper(
    () => settingApis.categoryDelete(id),
  );

  const preOrderServices = async (ids: string[]) => boundaryFuncWrapper(
    () => settingApis.sortServices(ids)
  );

  const addCategory = async (body: IEditCateBodyType) => {
    setLoadingPage(true);
    try {
      const res: IResponseDataBody<ICategoryItemData> = await settingApis.createCategory(body);
      if (res.data.data) {
        dispatch(settingServiceActions.serviceActs.activeCate(res.data.data.id));
        dispatch(shopActions.getNewCategories.fetch());
      }
    } catch (error) { }
    finally {
      setLoadingPage(false);
    }
  };

  const addMoreServiceForCate = async (body: IEditCateBodyType) => boundaryFuncWrapper(
    () => settingApis.addMoreServiceByCate(body)
  );

  const applyDiscountItemsCategory = (cateId: string, type: DISCOUNT_VALUE_TYPE, value: number) => boundaryFuncWrapper(
    () => settingApis.applyDiscountItemsForCate(cateId, value, type),
  );

  return ({
    setActiveCate,
    deleteServices,
    applySupplyFee,
    editNameCate,
    editNameService,
    updateInfoServices,
    deleteCategory,
    preOrderServices,
    addCategory,
    addMoreServiceForCate,
    applyDiscountItemsCategory,
  });
};

export default useSettingService;
